import { createFileRoute } from "@tanstack/react-router";
import { WorkflowEditorPage } from "@/components/schema/WorkflowEditorPage";

/** Administration: one workflow with its statuses grouped by category. */
export const Route = createFileRoute("/_app/admin/workflows/$workflowId")({ component: WorkflowEditor });

function WorkflowEditor() {
  const { workflowId } = Route.useParams();
  return <WorkflowEditorPage workflowId={workflowId} />;
}
